import React from 'react';

const ViewToggle = ({ currentView, onViewChange }) => {
  return (
    <div className="flex items-center bg-gray-800 rounded-lg p-1 border border-gray-700">
      <button
        onClick={() => onViewChange('grid')}
        className={`px-3 py-2 text-sm font-medium rounded-md transition-all duration-150 flex items-center gap-2 ${
          currentView === 'grid'
            ? 'bg-gray-700 text-white shadow-md'
            : 'text-gray-400 hover:text-white'
        }`}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
          />
        </svg>
        Grid
      </button>
      <button
        onClick={() => onViewChange('list')}
        className={`px-3 py-2 text-sm font-medium rounded-md transition-all duration-150 flex items-center gap-2 ${
          currentView === 'list'
            ? 'bg-gray-700 text-white shadow-md'
            : 'text-gray-400 hover:text-white'
        }`}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 10h16M4 14h16M4 18h16"
          />
        </svg>
        List
      </button>
    </div>
  );
};

export default ViewToggle;
